import React from 'react';
import ReactDOM from 'react-dom';
import TermsAndConditionsModal from './TermsAndConditionsModal';

class TermsAndConditions {
    constructor() {
        this.initializeModal();
    }

    /**
     * Initialize the terms and conditions modal
     */
    initializeModal(): void {
        // Create a container for the React component
        const modalContainer = document.createElement( 'div' );
        modalContainer.id = 'cfw-terms-modal-container';
        document.body.appendChild( modalContainer );

        // Render the React component
        ReactDOM.render( React.createElement( TermsAndConditionsModal ), modalContainer );

        // Hide the original terms and conditions content
        const termsAndConditionsContent = document.querySelector( '.woocommerce-terms-and-conditions' );
        if ( termsAndConditionsContent ) {
            ( termsAndConditionsContent as HTMLElement ).style.display = 'none';
        }
    }
}

export default TermsAndConditions;
